import { createFileRoute } from "@tanstack/react-router";
import { buildRouteHead } from "@/lib/seo/routeHead";
import SolutionDetail from "@/pages/SolutionDetail";

export const Route = createFileRoute("/zh-cn/industries/companion-diagnostics")({
  head: () => buildRouteHead("/zh-cn/industries/companion-diagnostics"),
  component: SolutionDetail,
});

